import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ArchiveRestore, ShoppingCart, Trash2 } from "lucide-react";
import { btn } from "@/components/common/btn";

// The "Archived" view of /clients (picked from the toolbar pill). Compact 4-column table with inline
// Restore + Delete actions; Delete only opens the confirm dialog, so the button itself is neutral.
// Extracted from Clients.jsx (Feb 2026, iter181).
export function ArchivedCustomersSection({
  archivedClients,
  handleRestore,
  setDeleteConfirmClient,
}) {
  return (
    <div data-testid="archived-customers-view">
      {archivedClients.length === 0 ? (
        <div className="text-center py-10 text-sm text-slate-500">No archived customers</div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow className="bg-muted/40">
              <TableHead className="th-std">Customer</TableHead>
              <TableHead className="th-std">Location</TableHead>
              <TableHead className="th-std">Facility Type</TableHead>
              <TableHead className="th-std">Rating</TableHead>
              <TableHead className="th-std w-[150px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {archivedClients.map((client) => (
              <TableRow key={client.id} className="table-row-hover" data-testid={`archived-client-row-${client.id}`}>
                <TableCell className="font-medium text-slate-600">
                  {client.customer_type === "parts_counter" ? (
                    <span className="flex items-center gap-1.5">
                      <ShoppingCart className="w-3.5 h-3.5 text-brand" />
                      {client.name}
                    </span>
                  ) : (
                    client.name
                  )}
                </TableCell>
                <TableCell className="text-sm text-slate-500">
                  {client.city || client.state ? [client.city, client.state].filter(Boolean).join(", ") : "-"}
                </TableCell>
                <TableCell className="text-sm text-slate-500">{client.facility_type || "-"}</TableCell>
                <TableCell className="text-sm text-slate-500">{client.rating || "-"}</TableCell>
                <TableCell>
                  <div className="flex gap-1">
                    <button type="button" className={btn("mode")} title="Put this customer back in the active list"
                      onClick={() => handleRestore(client.id)} data-testid={`btn-restore-client-${client.id}`}>
                      <ArchiveRestore className="w-3.5 h-3.5" />Restore
                    </button>
                    <button type="button" className={btn("nav")} title="Permanently delete this customer — asks you to confirm first"
                      onClick={() => setDeleteConfirmClient(client)} data-testid={`btn-delete-client-${client.id}`}>
                      <Trash2 className="w-3.5 h-3.5" />Delete
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
